import { render, staticRenderFns } from "./EmployeeFolderForm.vue?vue&type=template&id=019784bc&scoped=true&"
import script from "./EmployeeFolderForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeFolderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019784bc",
  null
  
)

export default component.exports